import React from 'react';
import VstModalContainer from '../components/layouts/modal-container-vstui';
import Dispatcher from '../dispatcher';

var VSTModals = {

  // globally show modals
  showVSTModal: function(data, refocusDOM, parentElement){
    this.modalToShow = this.modalToShow || [];
    Fraction.Helpers.vstModalCloseRefocus = Fraction.Helpers.vstModalCloseRefocus || [];
    if (refocusDOM){
      Fraction.Helpers.vstModalCloseRefocus.push(refocusDOM);
    } else {
      // console.warn('Please include refocus element for this modal.');
    }
    if (!data.menuId){
      // console.warn('Please include a menu id');
    }

    this.modalToShow.push(<VstModalContainer key={`modal-container-${data.menuId || data.title}`} {...data} modalCloseCallback={data.closeCallback || function(){}}  />);
    Dispatcher.emit(Dispatcher.MODAL_OPEN);
    if (Fraction.Helpers.modalRedraw){
      Fraction.Helpers.modalRedraw();
    }
    Fraction.Helpers.runAfterRender(() => {
      Fraction.Helpers.updateVSTModalLocation(parentElement);
      $(".modal").focus();
    });
  },

  removeVSTModal: function(callback, options){
    options = options || {};
    var parentModal;
    if (!parentModal){
      parentModal = $(".modal-vstui").last();
    }

    if (!parentModal.length) {
      // call callback and return
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    //this.modalCloseCallback();
    if (Fraction.Helpers.vstModalCloseRefocus && Fraction.Helpers.vstModalCloseRefocus.length>0){
      var refocus = Fraction.Helpers.vstModalCloseRefocus.pop();
      /*
      // Not really sure why we were ever doing this.
      // Next person who finds this should remove this block of code
      refocus.css("outline", "none").on("blur", function() {
        $(this).off("blur").css("outline", "");
      });
      */
      refocus.focus();
    }

    (function(callback){
      var fadeLength = options.fade || Fraction.Helpers.isSmallScreen() ? 0 : 100;
      parentModal.fadeOut(fadeLength, () => {
        if (Fraction.Helpers.modalToShow){
          Fraction.Helpers.modalToShow.pop();
          if (Fraction.Helpers.modalToShow.length === 0){
            Dispatcher.emit(Dispatcher.MODAL_CLOSE);
          }
        }
        if (Fraction.Helpers.modalRedraw){
          Fraction.Helpers.modalRedraw();
        }
        if (callback && (typeof callback)==="function"){
          callback();
        }
      });
    })(callback);
  },

  // Update modal location
  updateVSTModalLocation: function(modalElement){
    if (Fraction.Helpers.modalToShow){
      $(".modal-vstui").each(function(){
        if ($(this).hasClass("ignore-position")){return;}
        var fadeLength = Fraction.Helpers.isSmallScreen() ? 0 : 200;
        $(this).fadeIn(fadeLength, () => {});
        if (modalElement){
          $(this).css('width', 'auto');
          $(this).css('height', 'auto');
          $(this).find('.modal-title').css('font-size', '2.0rem');
          $(this).find('.modal-title').css('text-align', 'center');
          $(this).css('position', 'absolute');
          $(this).css('top', $(modalElement).offset().top+12);
          $(this).css('left', $(modalElement).offset().left+12);
          $(this).css('bottom', $(window).height()-($(modalElement).offset().top+$(modalElement).outerHeight(true))+12);
          $(this).css('right', $(window).width()-($(modalElement).offset().left+$(modalElement).outerWidth(true))+12);
        } else {

          if (!Fraction.Helpers.isSmallScreen()){
            var newTop = ($(document).height()/2.0)-($(this).height()/2)-40;
            var newLeft = ($(document).width()/2.0)-($(this).width()/2);

            // Taller modals might go out of bounds, so set a min value for this
            if (newTop < 10) {
              newTop = 10;
            }
            // If fixed top is set, use that
            if ($(this).attr("data-fixed-top")) {
              newTop = $(this).attr("data-fixed-top") + "px";
            }
            // If fixed left is set, use that
            if ($(this).attr("data-fixed-left")) {
              newLeft = $(this).attr("data-fixed-left") + "px";
            }

            $(this).css('top', newTop);
            $(this).css('left', newLeft);
          }
        }
      });
    }
  }

};

module.exports = VSTModals;
